import { Injector } from '@angular/core';
import {
  AUTH_METHOD,
  AUTH_METHOD_VIEW,
  AuthenticationMethod,
  AuthenticationResult,
  EndpointRedirectRequestStrategy,
  LoginFormComponent,
} from '@technocom/auth';
import { RouterService } from '@technocom/core';
import { LoginPhonePageComponent } from '@app/core/pages/login-phone-page/login-phone-page.component';
import { HrefUtils, HttpService, MimeType } from '@technocom/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequestWithParams } from '@technocom/common/http/lib/types/http-request-options';

export const jsonRequestStrategy = {
  provide: [AUTH_METHOD, AUTH_METHOD_VIEW, HttpService],
  execute: (
    method: AuthenticationMethod,
    runner: LoginFormComponent,
    http: HttpService,
  ): Observable<AuthenticationResult> => {
    return http
      .tryPost(method.endpoint, runner.getFormData(), {
        contentType: MimeType.APPLICATION_JSON,
      } as HttpRequestWithParams)
      .pipe(map(result => result || true));
  },
};

export function LoginMethodsInitializer(injector: Injector): AuthenticationMethod[] {
  return AuthenticationMethod.all([
    // Basic-аутентификация для локальной разработки
    // {
    //   id: 'basic',
    //   icon: 'fas fa-key',
    //   endpoint: environment.web.security.sessionEndpoint,
    //   disabled: isDevMode() !== true,
    //   request: BasicLoginRequestStrategy,
    //   button: {
    //     text: 'Basic',
    //     component: BasicLoginButtonComponent,
    //   },
    //   action: {
    //     text: 'Войти локально',
    //     component: UsernamePasswordLoginFormComponent,
    //     configure: (component: UsernamePasswordLoginFormComponent) => {
    //       component.hideRememberMe = true;
    //     },
    //   },
    // },
    // Серверная JEE-аутентификация (
    {
      id: 'oauth',
      icon: 'fas fa-sign-in-alt',
      endpoint: () => {
        return LoginEndpointBuilder(injector.get(RouterService), '/login');
      },
      external: true,
      request: EndpointRedirectRequestStrategy,
      button: {
        text: 'Вход',
        icon: 'fas fa-globe-americas',
      },
      action: {
        text: 'Войти',
      },
    },
    {
      id: 'local',
      icon: 'fas fa-sign-in-alt',
      endpoint: () => {
        return HrefUtils.join('person', 'registration', 'login'); // серверный урл для входа, на него уйдет запрос входа
      },
      styleRules: {
        height: '100%',
      },
      request: jsonRequestStrategy,
      button: {
        text: 'Личный кабинет мигранта',
        icon: 'fas fa-globe-europe',
      },
      action: {
        text: 'Войти',
        component: LoginPhonePageComponent, // твой компонент формы входа, расширяющий LoginFormComponent из auth
      },
    },
  ]);
}

function LoginEndpointBuilder(router: RouterService, targetUrl: string): string {
  // достаём урл для возврата - либо установленный редирект, либо активную страницу
  let path = router.getRedirectUrl() || router.routerUrl;

  // если возвращаться некуда или путь указывает на раздел входа, то идём в корень
  if (path == null || path.includes('/login') || path.includes('/registration')) {
    path = '/';
  }

  // создаём урл на сервер
  return router.apiTo(targetUrl, {
    // нормализуем урл (добавляем адрес сервера, если нет)
    url: router.normalizeUrl(path),
  });
}
